import React from "react";
import { Button, Result, Typography, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { FrownOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const PageNotFound = () => {
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const goBack = () => {
    navigate(-1); // Navigate to the previous page in the history stack
  };

  return (
    <div style={styles.container}>
      <Result
        status="404"
        title={
          <Title level={2} style={styles.title}>
            Oops! Page Not Found
          </Title>
        }
        subTitle={
          <Text style={styles.subtitle}>
            Sorry, the page you are looking for does not exist.
          </Text>
        }
        icon={<FrownOutlined style={styles.icon} />}
        extra={
          <Space>
            {/* <Button
              type="primary"
              size="large"
              onClick={() => navigate("/login/dashboard")}
            >
              Go Back Dashboard
            </Button> */}
            <Button size="large" onClick={goBack} style={styles.contactButton}>
              Go Back
            </Button>
          </Space>
        }
      />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f7f7f7",
  },
  title: {
    fontSize: "30px",
    fontWeight: "bold",
    color: "#333",
  },
  subtitle: {
    fontSize: "18px",
    color: "#666",
  },
  icon: {
    fontSize: "50px",
    color: "#FF4D4F",
  },
  contactButton: {
    backgroundColor: "#FF4D4F",
    color: "#fff",
    border: "none",
  },
};

export default PageNotFound;
